import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import FixtureReference from '../configuration/fixture/FixtureReference'
import FixtureAssemblyReference from '../configuration/fixture/FixtureAssemblyReference'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

export default function MainFixture (props) {
  const activePath = props.activePath
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Fixture'),
      component: <FixtureReference />,
      to: '/resources/fixtureReference',
      permissionCode: 'FIXTURE TAB'
    },
    {
      title: t_('Fixture assembly'),
      component: <FixtureAssemblyReference />,
      to: '/resources/fixtureAssemblyReference',
      permissionCode: 'FIXTURE ASSEMBLY'
    }
  ]

  return <SmartNavigator componentsInfo={componentsInfo} selected={activePath} />
}
